<app-landing-nav-item [item]="planNavItem" [applyContentBorder]="userHasPlan"></app-landing-nav-item>